import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M27.018 14h3v2h-3a1 1 0 1 0 0 2h3v2h-3a1 1 0 1 0 0 2h3c0 .903-.2 1.776-.58 2.573a1 1 0 1 0 1.806.86 8 8 0 0 0 .774-3.435V10.002a8 8 0 0 0-8-8.002c-4.413 0-8 3.585-8 8.002v2.04a1 1 0 1 0 2 0v-2.04a6.006 6.006 0 0 1 6-6.002c3.313 0 6 2.688 6 6.002V12h-3a1 1 0 1 0 0 2m3.606 18.02-2.92-2.92a8.002 8.002 0 0 1-11.686-7.102v-4.584L6.311 7.707c-.943-.943.471-2.357 1.414-1.414l34 34c.943.943-.471 2.357-1.414 1.414l-8.248-8.248a13.9 13.9 0 0 1-7.046 2.506l.001.035v8h4c1.333 0 1.333 2 0 2h-10c-1.333 0-1.333-2 0-2h4v-8.035c-7.265-.513-13-6.568-13-13.965a1 1 0 1 1 2 0c0 6.628 5.372 12 12 12 2.388 0 4.667-.698 6.606-1.98M18.018 19.414l8.177 8.178a6.002 6.002 0 0 1-8.177-5.593zm19 1.586a1 1 0 0 0-1 1 11.94 11.94 0 0 1-2.146 6.85 1 1 0 1 0 1.641 1.144A13.94 13.94 0 0 0 38.018 22a1 1 0 0 0-1-1",
      clipRule: "evenodd"
    }
  )
);
var SvgMicOffOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MicOffOutlined_default = SvgMicOffOutlined;

export { MicOffOutlined_default as default };
